<template>
  <section class="btn-announcement-page">
    <header class="btn-announcement-page__header">
      <h1 class="btn-announcement-page__header-title">Recent Announcement</h1>
      <IconByTheNumbers width="45" height="45" />
    </header>
    <div class="btn-announcement-page__content">
      <h3 class="btn-announcement-page__title">
        {{ announcement.name }}
      </h3>
      <img
        v-if="announcement.image"
        :src="getAnnouncementImage(announcement.image)"
        alt="Announcement Image"
        class="btn-announcement-page__image"
      />
      <p class="btn-announcement-page__date">
        {{ getFormattedDate(announcement.date) }}
      </p>
      <article
        v-html="announcement.content"
        class="btn-announcement-page__content-container"
      />
    </div>
    <footer
      v-if="otherAnnouncements && otherAnnouncements.length > 0"
      class="btn-announcement-page__read-more"
    >
      <h3 class="btn-announcement-page__read-more-title">Read More...</h3>
      <CarouselContainer class="btn-announcement-page__read-more-carousel">
        <PreviewAnnouncement
          v-for="otherAnnouncement in otherAnnouncements"
          :key="otherAnnouncement.id"
          :announcement="otherAnnouncement"
          :carousel="true"
          class="btn-announcement-page__read-more-carousel-card"
        />
      </CarouselContainer>
    </footer>
  </section>
</template>

<script>
  import CarouselContainer from '~/components/carousel/CarouselContainer.vue';
  import PreviewAnnouncement from '~/components/products/by-the-numbers/PreviewAnnouncement.vue';
  import IconByTheNumbers from '~/components/icon/IconByTheNumbers.vue';

  export default {
    name: 'ByTheNumbersAnnouncmentPage',
    components: {
      CarouselContainer,
      PreviewAnnouncement,
      IconByTheNumbers,
    },
    props: {
      announcement: {
        type: Object,
        required: true,
      },
      otherAnnouncements: {
        type: Array,
        required: true,
      },
    },
    data: () => ({
      hoveringCards: [],
    }),
    methods: {
      goToAnnouncement(slug) {
        window.location.href = `/by-the-numbers/announcement/${slug}`;
      },
      getAnnouncementImage(image) {
        if (!image) return '/images/placeholder-image.png';
        const imageUrl = image.charAt(0) === '/' ? image.substring(1) : image;
        return `/storage/${imageUrl}`;
      },
      getFormattedDate(date) {
        return new Date(date).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-announcement-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4rem;
    min-height: 75vh;
    width: 100%;

    &__header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;

      &-title {
        font-size: 2rem;
        font-weight: 700;
        text-transform: capitalize;
        margin-right: 10px;
      }
    }

    &__content {
      padding: 0;
      margin: 0;
      width: 100%;
      @include screen-lg {
        width: 60%;
      }
    }

    &__title {
      margin-bottom: 1rem;
      @include screen-lg {
        font-size: 30px;
        margin-bottom: 2rem;
      }
    }

    &__image {
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: center;
    }

    &__date {
      font-size: 18px;
      font-weight: 900;
      margin-bottom: 1rem;
      color: var(--itr-grey-mid);
      @include screen-lg {
        margin-bottom: 3rem;
      }
    }

    &__content-container {
      margin: 56px 0;
    }

    &__read-more {
      display: flex;
      flex-direction: column;
      width: 100%;

      &-title {
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 35px;
      }

      &-carousel {
        :deep(.carousel-container__inner) {
          display: flex;
          gap: 36px;
          padding-bottom: 50px;
        }

        &-card {
          width: 80vw;
          max-width: 500px;
          scroll-snap-align: start;
        }
      }
    }
  }
</style>
